import { LucideIcon, Plus } from 'lucide-react'

interface EmptySectionPlaceholderProps {
  icon: LucideIcon
  title: string
  description: string
  buttonLabel: string
  onButtonClick?: () => void
}

/**
 * Placeholder for empty profile sections with icon, description, and CTA button
 */
export function EmptySectionPlaceholder({
  icon: Icon,
  title,
  description,
  buttonLabel,
  onButtonClick,
}: EmptySectionPlaceholderProps) {
  return (
    <div className="flex flex-col items-center py-12">
      {/* Icon Circle */}
      <div className="w-20 h-20 rounded-[40px] bg-slate-200 flex items-center justify-center mb-6">
        <Icon className="w-6 h-6 text-slate-500" />
      </div>

      {/* Title */}
      <h3 className="text-xl font-normal text-slate-900 text-center mb-2">
        {title}
      </h3>

      {/* Description */}
      <p className="text-sm text-slate-500 text-center max-w-[280px] leading-relaxed mb-6">
        {description}
      </p>

      {/* CTA Button */}
      <button
        onClick={onButtonClick}
        className="flex items-center gap-2 px-6 py-3 rounded-[48px] text-white font-normal text-base"
        style={{
          background: 'linear-gradient(106.66deg, rgba(70, 105, 237, 1) 0%, rgba(54, 84, 233, 1) 100%)',
        }}
      >
        <Plus className="w-5 h-5" />
        {buttonLabel}
      </button>
    </div>
  )
}
